export interface GuestWishlistLoginInput {
  localIds: number[]
  serverIds: number[]
  currentTrackingId: string
  lastTrackingId: string | null
  snapshotIds: number[]
}

function uniqueIds (ids: number[]): number[] {
  return Array.from(new Set(ids.filter(id => Number.isFinite(id) && id > 0)))
}

/**
 * Ids to persist after a login / session restore.
 *
 * Same account (or first login with no previous tracking id): union of local
 * draft and server list. Account switch: server list plus only hearts added
 * after logout (local minus the logout snapshot). Without a snapshot, local
 * leftovers from account A must not be merged into account B.
 */
export function idsForLogin (input: GuestWishlistLoginInput): number[] {
  const localIds = uniqueIds(input.localIds)
  const serverIds = uniqueIds(input.serverIds)
  const snapshotIds = uniqueIds(input.snapshotIds)

  if (input.lastTrackingId && input.lastTrackingId !== input.currentTrackingId) {
    const snapshot = new Set(snapshotIds)
    const addedAfterLogout = snapshotIds.length > 0
      ? localIds.filter(id => !snapshot.has(id))
      : []
    return uniqueIds([...serverIds, ...addedAfterLogout])
  }

  return uniqueIds([...serverIds, ...localIds])
}
